module.exports = __webpack_public_path__ + "img/tick_square.0f170e8d.svg";